export const environment = {
    production: false,
    useEmulators: false,
    appName: "de.diwima.rcweb.test",
    firebaseConfig: {
        apiKey: "AIzaSyBrxcEmI-crQ32fGPViDx3oNozeub11nCM",
        authDomain: "diwima-de-test.firebaseapp.com",
        databaseURL: "https://diwima-de-test.firebaseio.com",
        projectId: "diwima-de-test",
        storageBucket: "diwima-de-test.appspot.com",
        messagingSenderId: "419955134464",
        appId: "1:419955134464:web:0536036572a2f8b0cb48e5"
    },
    appPostFix: '-Test',
    mapBoxToken: "pk.eyJ1IjoiemlmZmVyZWlucyIsImEiOiJja2dhdTlmOGcwYXNzMnRwZDR3cXpkY2thIn0.pMsxXRhLz448Ne2BBiXdxg",
    mapBoxStyleOutdoors: "mapbox://styles/ziffereins/cmam7y4pl01fj01s4bcnz57e7",
    mapBoxStyleStreets: "mapbox://styles/ziffereins/ckgatv0ee162y19o2mc7i3uus",
    versionNumber: "1.3.21", 
    versionCode: 74,
    apiURL: "https://europe-west1-diwima-de-test.cloudfunctions.net/app/v1",
    invitationURL: "https://pub-invitation-test.web.app"
}